"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
function isBetweenDayTime(rule) {
    const now = (0, moment_1.default)();
    const weekday = now.weekday();
    const hasTimeRangeSetting = lodash_1.default.chain(Object.values(rule.startTime)).concat(Object.values(rule.endTime)).some(n => n !== 0).value();
    const hasWeekdaysSetting = rule.weekdays.length > 0;
    let isInTimeRange = false;
    if (hasTimeRangeSetting) {
        let startTime = (0, moment_1.default)().hour(0).minute(0);
        let endTime = (0, moment_1.default)().hour(23).minute(59);
        startTime = startTime.hour(rule.startTime.hour).minute(rule.startTime.minute);
        endTime = endTime.hour(rule.endTime.hour).minute(rule.endTime.minute);
        isInTimeRange = now.isBetween(startTime, endTime);
    }
    else {
        isInTimeRange = true;
    }
    const isInWeekdays = !hasWeekdaysSetting || // 沒有設定 weekdays
        rule.weekdays.includes(weekday); // weekday 符合 weekdays 設定
    return isInTimeRange && isInWeekdays;
}
function getComboList(batches, comboRules) {
    let isDiscountedItemsMatched = false;
    let isMandatoryItemsMatched = false;
    const comboLists = lodash_1.default.flatMapDeep(batches, (batch, batchIndex) => {
        return lodash_1.default.map(batch.items, (item, itemIndex) => {
            return Array(item.quantity).fill({
                batchIndex,
                itemIndex,
                itemId: item.menuId,
                matched: false,
                modifier: {},
            });
        });
    });
    lodash_1.default.forEach(comboRules, (comboRule) => {
        if (isBetweenDayTime(comboRule) === true && comboRule.enabled) {
            isDiscountedItemsMatched = false;
            isMandatoryItemsMatched = false;
            const mandatoryItems = [];
            const discountedItems = [];
            const tempCombos = {
                mandatoryItems: mandatoryItems,
                discountedItems: discountedItems,
            };
            const matchedIndex = [];
            lodash_1.default.forEach(comboRule.mandatoryItems, (mandatoryItem) => {
                let tempComboMandatoryItem = [];
                let availableComboCount = 0;
                lodash_1.default.forEach(lodash_1.default.filter(comboLists, c => c.matched === false), (comboList, index) => {
                    // 已matched的不再處理
                    if (matchedIndex.includes(index))
                        return;
                    // 使用numpad增加數量 要特別去處理
                    const isUseBartoAddQuantity = comboLists.filter(c => c.batchIndex === comboList.batchIndex &&
                        c.itemIndex === comboList.itemIndex &&
                        c.itemId === comboList.itemId).length > 1;
                    const lastTempComboDiscountedItemIndex = lodash_1.default.flatMapDeep(tempCombos.discountedItems).findIndex((r) => comboList.batchIndex === r.batchIndex &&
                        comboList.itemIndex === r.itemIndex &&
                        comboList.itemId === r.itemId);
                    if (mandatoryItem.itemIds.includes(comboList.itemId) && (lastTempComboDiscountedItemIndex < 0 || isUseBartoAddQuantity)) {
                        tempComboMandatoryItem.push(comboList);
                        matchedIndex.push(index);
                    }
                    // 已滿足了當前mandatoryItems的數量
                    if (tempComboMandatoryItem.length === mandatoryItem.match) {
                        if (tempCombos.mandatoryItems[availableComboCount] === undefined) {
                            tempCombos.mandatoryItems[availableComboCount] = [];
                        }
                        tempCombos.mandatoryItems[availableComboCount].push(tempComboMandatoryItem);
                        tempComboMandatoryItem = [];
                        // 已滿足了當前mandatoryItems的total組合數量 開始計算discountedItems組合
                        if (tempCombos.mandatoryItems[availableComboCount].length === comboRule.mandatoryItems.length) {
                            lodash_1.default.forEach(comboRule.discountedItems, (discountedItem) => {
                                var _a, _b;
                                let tempComboDiscountedItems = [];
                                lodash_1.default.forEach(lodash_1.default.filter(comboLists, c => c.matched === false), (comboList, currentindex) => {
                                    // 已matched的不再處理
                                    if (matchedIndex.includes(currentindex))
                                        return;
                                    // 使用numpad增加數量 要特別去處理
                                    const isUseBartoAddQuantity = comboLists.filter(c => c.batchIndex === comboList.batchIndex &&
                                        c.itemIndex === comboList.itemIndex &&
                                        c.itemId === comboList.itemId).length > 1;
                                    const tempCombomandatoryItemIndex = lodash_1.default.flatMapDeep(tempCombos.mandatoryItems).findIndex((r) => comboList.batchIndex === r.batchIndex &&
                                        comboList.itemIndex === r.itemIndex &&
                                        comboList.itemId === r.itemId);
                                    const tempComboDiscountedItemIndex = lodash_1.default.flatMapDeep(tempCombos.discountedItems).findIndex((m) => comboList.batchIndex === m.batchIndex &&
                                        comboList.itemIndex === m.itemIndex &&
                                        comboList.itemId === m.itemId);
                                    if (discountedItem.itemIds.includes(comboList.itemId) && ((tempCombomandatoryItemIndex < 0 && tempComboDiscountedItemIndex < 0) || isUseBartoAddQuantity)) {
                                        tempComboDiscountedItems.push(comboList);
                                        matchedIndex.push(currentindex);
                                    }
                                    if (tempComboDiscountedItems.length === discountedItem.match) {
                                        if (tempCombos.discountedItems[availableComboCount] === undefined) {
                                            tempCombos.discountedItems[availableComboCount] = [];
                                        }
                                        tempCombos.discountedItems[availableComboCount].push(tempComboDiscountedItems);
                                        tempComboDiscountedItems = [];
                                        return true;
                                    }
                                });
                                if (((_a = tempCombos.discountedItems[availableComboCount]) === null || _a === void 0 ? void 0 : _a.length) === ((_b = comboRule.discountedItems) === null || _b === void 0 ? void 0 : _b.length)) {
                                    return true;
                                }
                            });
                        }
                        availableComboCount++;
                    }
                });
            });
            console.log('tempCombos', tempCombos);
            lodash_1.default.forEach(tempCombos.mandatoryItems, (mandatoryItems, mandatoryItemIndex) => {
                var _a;
                const reduceMatchedMandatoryItems = mandatoryItems.reduce((result, value, key) => {
                    var _a;
                    if (lodash_1.default.size(value) === ((_a = comboRule === null || comboRule === void 0 ? void 0 : comboRule.mandatoryItems[key]) === null || _a === void 0 ? void 0 : _a.match)) {
                        result.push(true);
                    }
                    else {
                        result.push(false);
                    }
                    return result;
                }, []);
                const discountedItems = (_a = tempCombos.discountedItems) === null || _a === void 0 ? void 0 : _a[mandatoryItemIndex];
                if (discountedItems === undefined)
                    return true;
                const reduceMatchedDiscountedItems = discountedItems.reduce((result, value, key) => {
                    var _a;
                    if (lodash_1.default.size(value) === ((_a = comboRule === null || comboRule === void 0 ? void 0 : comboRule.discountedItems[key]) === null || _a === void 0 ? void 0 : _a.match)) {
                        result.push(true);
                    }
                    else {
                        result.push(false);
                    }
                    return result;
                }, []);
                isDiscountedItemsMatched = lodash_1.default.every(reduceMatchedDiscountedItems, match => match) && reduceMatchedDiscountedItems.length === comboRule.discountedItems.length;
                isMandatoryItemsMatched = lodash_1.default.every(reduceMatchedMandatoryItems, match => match) && reduceMatchedMandatoryItems.length === comboRule.mandatoryItems.length;
                if (!isDiscountedItemsMatched || !isMandatoryItemsMatched)
                    return true;
                lodash_1.default.forEach(mandatoryItems, (mandatoryItem) => {
                    lodash_1.default.forEach(mandatoryItem, m => {
                        const comboListsIndex = comboLists.findIndex(comboList => comboList.batchIndex === m.batchIndex &&
                            comboList.itemIndex === m.itemIndex &&
                            comboList.itemId === m.itemId &&
                            comboList.matched === false);
                        if (comboListsIndex >= 0) {
                            comboLists[comboListsIndex] = Object.assign(Object.assign({}, comboLists[comboListsIndex]), { matched: true });
                        }
                    });
                });
                lodash_1.default.forEach(discountedItems, (discountedItem, discountedItemIndex) => {
                    lodash_1.default.forEach(discountedItem, d => {
                        const comboListsIndex = comboLists.findIndex(comboList => comboList.batchIndex === d.batchIndex &&
                            comboList.itemIndex === d.itemIndex &&
                            comboList.itemId === d.itemId &&
                            comboList.matched === false);
                        if (comboListsIndex >= 0) {
                            comboLists[comboListsIndex] = Object.assign(Object.assign({}, comboLists[comboListsIndex]), { matched: true, modifier: Object.assign(Object.assign({}, comboRule.discountedItems[discountedItemIndex].modifier), { name: comboRule.name }) });
                        }
                    });
                });
            });
        }
    });
    return comboLists;
}
exports.default = getComboList;
//# sourceMappingURL=getComboList.js.map